var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCloseIconModal = function SvgCloseIconModal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#56565A",
    d: "M6 4.822 10.125.697l1.178 1.178L7.178 6l4.125 4.125-1.178 1.178L6 7.178l-4.125 4.125-1.178-1.178L4.822 6 .697 1.875 1.875.697 6 4.822"
  })));
};
export default SvgCloseIconModal;